export const APP_TITLE = '士腾科技 · OTA系统';
